var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-camera",
    width: "80px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50,-50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270.72 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    keySplines: "0.5 0.5 0.5 0.5",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05125",
    d: "M54.3,28.1h34.2c-4.5-9.3-12.4-16.7-21.9-20.8L45.7,28.1L54.3,28.1L54.3,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb813",
    d: "M61.7,7.3C51.9,4,41.1,4.2,31.5,8.1v29.5l6.1-6.1L61.7,7.3C61.7,7.3,61.7,7.3,61.7,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7fbb42",
    d: "M28.1,11.6c-9.3,4.5-16.7,12.4-20.8,21.9l20.8,20.8v-8.6L28.1,11.6C28.1,11.6,28.1,11.6,28.1,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a0da",
    d: "M31.5,62.4L7.3,38.3c0,0,0,0,0,0C4,48.1,4.2,58.9,8.1,68.5h29.5L31.5,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05125",
    d: "M45.7,71.9H11.5c0,0,0,0,0,0c4.5,9.3,12.4,16.7,21.9,20.8l20.8-20.8H45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdb813",
    d: "M62.4,68.5L38.3,92.6c0,0,0,0,0,0c9.8,3.4,20.6,3.1,30.2-0.8V62.4L62.4,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7fbb42",
    d: "M71.9,45.7v8.6v34.2c0,0,0,0,0,0c9.3-4.5,16.7-12.4,20.8-21.9L71.9,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a0da",
    d: "M91.9,31.5C91.9,31.5,91.9,31.5,91.9,31.5l-29.5,0l0,0l6.1,6.1l24.1,24.1c0,0,0,0,0,0 C96,51.9,95.8,41.1,91.9,31.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.945d5bb3c2bb3c49c354353fbf3178c9.svg";
export { ForwardRef as ReactComponent };